import { useEffect, useState } from "react";
import "./stockLimitQuantityChart.scss";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type Props = {
  minQuantity: number;
  maxQuantity: number;
  currentQuantity: number;
  graphPercentage: number;
};

const StockLimitQuantityChart: React.FC<Props> = ({
  minQuantity,
  maxQuantity,
  currentQuantity,
  graphPercentage,
}) => {
  const [indicatorPosition, setIndicatorPosition] = useState("50%");
  const [trackColor, setTrackColor] = useState("#3ba272");

  useEffect(() => {
    const calculatePosition = ():any => {
      if (graphPercentage === 0) {
        if (currentQuantity > 0 && minQuantity !== null && maxQuantity !== null) {
          setTrackColor("#ef6666");
          return "90%"; 
        } else if (currentQuantity < 0) {
          setTrackColor("#ef6666");
          return "5%"; 
        } 
        else if (( minQuantity===0) && (maxQuantity ===0) && currentQuantity === 0) {
          setTrackColor("#3ba272"); 
          return "50%"; 
        } 
        else if (minQuantity === 0 && maxQuantity === 0 && currentQuantity >0) {

          setTrackColor("#ef6666"); 
          return "90%"; 
        } 
        else if (currentQuantity === minQuantity) {
          setTrackColor("#3ba272");
          return "13%"; 
        } else if (currentQuantity === maxQuantity) {
          setTrackColor("#3ba272");
          return "83%"; 
        } 
        else {
          setTrackColor("#ef6666");
          return "5%";
        }
      }
      if (minQuantity === null && maxQuantity === null && currentQuantity > 0) {
        setTrackColor("#3ba272"); 
        return "90%"; 
      }
   

       if (currentQuantity < minQuantity) {
        setTrackColor("#ef6666");
        return "5%";
      } else if (currentQuantity > maxQuantity) {
        setTrackColor("#ef6666");
        return "90%";
      }
 
      else if (currentQuantity === minQuantity && currentQuantity === maxQuantity) { 
        setTrackColor("#3ba272");
        return "50%"; 
      }
      else if (currentQuantity === minQuantity) {
        setTrackColor("#3ba272");
        return "13%"; 
      } else if (currentQuantity === maxQuantity) {
        setTrackColor("#3ba272");
        return "83%"; 
      } 
      else {
        setTrackColor("#3ba272");
        const range = maxQuantity - minQuantity;
        const currentInRange = currentQuantity - minQuantity;
        const percentageWithinRange = (currentInRange / range) * 80; 
        const clampedPercentage = Math.max(
          10,
          Math.min(85, 15 + percentageWithinRange)
        );
        return `${clampedPercentage}%`;
      }
    };

    setIndicatorPosition(calculatePosition());
  }, [graphPercentage, minQuantity, maxQuantity, currentQuantity]);
  return (
    <div className="slider-container">
      <div className="slider-track">
        {/* <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="min-tooltip">{`Minimum Quantity : ${minQuantity?minQuantity:0}`}</Tooltip>}
        > */}
          <div className="slider-min-line">
          <span className="min-line-text">{minQuantity !== null ? minQuantity : 0}</span>
          </div>
        {/* </OverlayTrigger> */}

        {/* <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="max-tooltip">{`Maximum Quantity : ${maxQuantity?maxQuantity:0}`}</Tooltip>}
        > */}
          <div className="slider-max-line">
          <span className="min-line-text">{maxQuantity !== null ? maxQuantity : 0}</span>
</div>
        {/* </OverlayTrigger> */}

        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="current-tooltip">{`Current Quantity : ${currentQuantity}`}</Tooltip>}
        >
          <div
            className="slider-indicator"
            style={{ left: indicatorPosition, backgroundColor: trackColor }}
          ></div>
        </OverlayTrigger>
      </div>
    </div>
  );
};

export default StockLimitQuantityChart;
